import { prepareBankAmount } from 'adapters';

export const getSquareSuccessMessage = (data = {}) => {
	const amount =
		typeof data.amount_money?.amount !== 'undefined'
			? prepareBankAmount({ amount: data.amount_money.amount })
			: '"missing data"';
	const currency = data.amount_money?.currency ?? '"missing data"';

	return `Your payment of ${amount} ${currency} has been processed successfully`;
};
